


export const GetCities = async () => {

    const res = await fetch(`https://booking.sila-avia.ru/websky/json/dependence-cities?isBooking=true&returnPoints=origin&type=json`, {
        method: 'GET',
    });

    return res.json();

}
